"use client";

import "@fortawesome/fontawesome-free/css/all.css";
import "@radix-ui/themes/styles.css";

import ErrorPage from "@soprisapps/components/pages/ErrorPage";
import { Theme } from "@soprisapps/components/components/radix/Theme";

export default function NotFound() {
  return (
    <Theme>
      <ErrorPage statusCode={404} />
    </Theme>
  );
}
